module.exports = __webpack_public_path__ + "static/media/5_Condiciones_excepcionales.6494d6d8.mp3";